import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="flex-1 p-8 md:p-12 flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">
                  {appInfo.title}
                </h2>
                <p className="mt-4 text-sm text-foreground-500 leading-relaxed">{appInfo.desc}</p>
                <div className="flex flex-wrap gap-2 mt-6">
                  {appInfo.features.map((f, i) => (
                    <span
                      key={i}
                      className="flex items-center gap-1.5 text-xs text-foreground-500 bg-background-50 px-3 py-1.5 rounded-md border border-background-200 whitespace-nowrap"
                    >
                      <i className="ri-check-line text-primary-400 text-xs"></i>
                      {f}
                    </span>
                  ))}
                </div>
                <div className="flex gap-3 mt-7">
                  <button className="px-6 py-2.5 bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap">
                    添加到桌面
                  </button>
                  <button className="px-6 py-2.5 border border-background-300 text-foreground-600 rounded-md hover:border-primary-400/30 hover:text-primary-400 transition-colors text-sm cursor-pointer whitespace-nowrap">
                    了解更多
                  </button>
                </div>
              </div>
              <div className="lg:w-[320px] flex-shrink-0 bg-gradient-to-br from-primary-500/8 to-accent-500/8 p-8 flex items-center justify-center">
                <div className="w-40 h-72 bg-background-50 rounded-2xl border-4 border-background-300/60 shadow-lg overflow-hidden">
                  <div className="h-10 bg-background-200 flex items-center justify-center">
                    <span className="text-[8px] text-foreground-400">樱花TV</span>
                  </div>
                  <div className="p-3 space-y-2">
                    <div className="h-16 bg-background-200 rounded-md"></div>
                    <div className="h-2 bg-background-200 rounded w-3/4"></div>
                    <div className="h-2 bg-background-200 rounded w-1/2"></div>
                    <div className="h-16 bg-background-200 rounded-md mt-2"></div>
                    <div className="h-2 bg-background-200 rounded w-2/3"></div>
                    <div className="h-2 bg-background-200 rounded w-1/3"></div>
                    <div className="h-16 bg-background-200 rounded-md mt-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}